import axios from 'axios'

import { session } from '../load-config';
import { getLocalTimeZone } from '../utils/utils';

function randomString(n = 6) {
  var s = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  return Array(n).join().split(',').map(function () { return s.charAt(Math.floor(Math.random() * s.length)); }).join('');
}

export async function getReservation({
  resNumberOrReference,
  stationId,
  resCheckOutDate,
  appVersionId,
  language,
  autoSearch = false,
  secondTry = false,
  paymentsSession = false,
}) {
  const referrer = encodeURIComponent(document.referrer)

  const metricsParams = JSON.parse(sessionStorage.getItem('metricsParams'))
  const originTag = metricsParams?.originTag || undefined

  const res = await axios.get('/reservation-mobile', {
    params: {
      resNumberOrReference,
      resCheckOutDate,
      stationTimeZone: getLocalTimeZone(),
      stationId,
      appVersionId,
      nationality: language,
      autoSearch,
      secondTry,
      originTag,
      paymentsSession,
    },
    withCredentials: true,
    validateStatus: (status) => (status >= 200 && status < 300) || (status >= 400 && status < 500)
  })
  if (res.status >= 400 && res.status < 500) {
    throw new Error(res.data);
  }

  if (res.status >= 200 && res.status < 300) {
    if (res.data.sessionId) {
      session.setSessionId(res.data.sessionId)
    }
    return res.data;
  }

  throw new Error();
}
